import styled from 'styled-components'

export const CountdownContainer = styled.div`
  position: relative;

  display: flex;
  aspect-ratio: 16/9;

  justify-content: center;
  align-items: center;

  border-radius: var(--radius-brand);

  background: rgba(0, 0, 0, 0.9);
`

export const CountdownPoster = styled.img`
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  object-fit: cover;
`
export const Countdown = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: inline-flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;

  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 12px 16px 16px 16px;

  background: rgba(0, 0, 0, 0.9);

  backdrop-filter: blur(40px);
`

export const CountdownText = styled.div`
  opacity: 0.6;

  color: #fff;
  text-align: center;
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`

export const CountdownBoxes = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
`

export const CountdownBox = styled.div`
  display: flex;

  flex-direction: column;
  align-items: center;
  gap: 4px;

  border-radius: 8px;
  padding: 10px 0;

  width: 60px;

  background: rgba(255, 255, 255, 0.06);
`

export const CountdownBoxNumber = styled.div`
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  line-height: 100%;
`

export const CountdownBoxLabel = styled.div`
  opacity: 0.6;

  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 100%;
`

export const CountdownInfo = styled.div`
  opacity: 0.6;

  color: #fff;
  text-align: center;
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`
